<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        small
        class="ml-2"
        v-on="on"
      >
        <v-icon
          v-if="incomeTaxDetail.income_tax_number"
          color="primary"
        >
          mdi-pencil
        </v-icon>

        <v-icon
          v-else
          color="hrissecondary"
        >
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Employee Income Tax Detail"
      :text="incomeTaxDetail.income_tax_number ? 'Update employee income tax detail':'Create employee income tax detail'"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="incomeTaxNumber"
                v-validate="'required|length:13|validAlphanumeric'"    
                counter="13"
                maxlength="13"
                :error-messages="errors.collect('incomeTaxNumber')"
                data-vv-name="incomeTaxNumber"
                data-vv-as="Income tax number"
                label="Income Tax Number"
                @input="incomeTaxNumber = incomeTaxNumber.toUpperCase()"
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>  
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      incomeTaxDetail: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        incomeTaxNumber: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.incomeTaxNumber = this.incomeTaxDetail.income_tax_number

        this.loading = false

        this.$validator.extend('validAlphanumeric', {
          getMessage (field, args) {
            return 'Employee income tax number should not contain any special character'     
          },
          validate (value, args) {
            const regex = /^[A-Z0-9]*$/
            return regex.test(value)
          },
        })                      
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.employeePayrollIncomeTax().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          income_tax_number: this.incomeTaxNumber,
        }
      },
    },
  }
</script>
